export default "__VITE_ASSET__ur4K5vXd__ 1440w, __VITE_ASSET__p64jtJm0__ 820w, __VITE_ASSET__fa0SXloQ__ 500w";